import { graphql } from 'react-relay';

export const getDrawingSetAnnotationQuery = graphql`
    query getDrawingSetAnnotationQuery($id: ID!) {
        drawingSetAnnotation(id: $id) {
            ...drawingSetAnnotationFragment
        }
    }
`;
